import { STATE_MAPPINGS } from '@Shared.Angular/@types/stateMappings';

angular.module('flowingly.runner.print').config(config);

config.$inject = ['$stateProvider'];

function config($stateProvider) {
  $stateProvider.state(STATE_MAPPINGS.printFlowmodelschema, {
    url: '/flowmodelschema',
    templateUrl: 'Client/runner.print/runner.print.flowmodelschema.tmpl.html',
    controller: 'runnerPrintFlowModelSchemaController',
    controllerAs: '$ctrl'
  });
}
